import {
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Grid,
    TextField,
} from "@mui/material";
import { Formik } from "formik";
import { useState } from "react";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { wrapFormikHandleChange } from "../../../../infrastructure/utils/formatters";

import DefaultApiService from "../../../../infrastructure/api/default";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";
import DropdownPicker from "../../../components/shared/dropdown";
import FileUploader from "../../../components/shared/uploader/FileUploader";
 

const validationSchema = Yup.object().shape({ 
  title: Yup.string().required("لطفا این فیلد را پر کنید."),  
});

const TicketModifyPage = () => {
  const data = useLoaderData("root");
  let navigate = useNavigate();
  const { id: roleId } = useParams();

  const [loading, setLoading] = useState(false);

  const onNavigateToListPage = () => {
    navigate("/UM/Yeksa/Ticket");
  };
 
  // Submit Action
  const onSubmit = async (formValue, { setSubmitting }) => {
    setLoading(true);
    const sendData = { ...data, ...formValue };

    try {
      const res = await DefaultApiService.modifyApi(
        "UM/Ticket",
        sendData
      );

      if (res.isSuccess) {
        toast.success(res.message);
        onNavigateToListPage();
      } else {
        toast.error(res.message);
      }

      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");

      setLoading(false);
      setSubmitting(false);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={
              roleId !== "create"
                ? `ویرایش ${data?.ticket?.title}`
                : "ایجاد"
            }
          />

          <CardContent>
            <Formik
              initialValues={data.ticket}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => {
                const onMakeFormikVariable = (name) => ({
                  name: name,
                  fullWidth: true,
                  value: values[name],
                  error: errors[name] && touched[name],
                  helperText: errors[name] && touched[name] && errors[name],
                  variant: "outlined",
                });

                const handleFileChange = (fieldName) => (value) => {
                  if (value === undefined || value === null) {
                    return;
                  }
                  setFieldValue(fieldName, value);
                };

                return (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                   

                   
                    <Grid item xs={12} md={6} lg={4}>
                        <DropdownPicker
                          label="گروه"
                          onChange={(event) => {
                            setFieldValue("categoryId", event.target.value);
                             
                          }}
                          list={data.categoryList }
                          optionName="title"
                          optionValue="id"
                          {...onMakeFormikVariable("categoryId")}
                        />
                      </Grid>


                      <Grid item xs={12} md={6} lg={4}>
                        <TextField
                          label="عنوان"
                          type="string"
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("title")}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <DropdownPicker
                          label="اولویت"
                          onChange={(event) => {
                            setFieldValue("ticketPriority", event.target.value);
                          }}
                          list={data.ticketPriority}
                          filterable={false}
                          {...onMakeFormikVariable("ticketPriority")}
                        />
                      </Grid>
 
{/*                       
                    <Grid item xs={12} md={12} lg={12}>
  <CKEditor
    editor={ClassicEditor}
    data={values.content}
    onChange={(event, editor) => {
      const data = editor.getData();
      setFieldValue('content', data);
    }}
  />
  {errors.content && touched.content && <div>{errors.content}</div>}
</Grid> */}

<Grid item xs={12} md={6} lg={12}>
                        <TextField
                          label="محتوا"
                          type="string"
                          multiline
                          minRows={4}
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("content")}
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <FileUploader
                          moduleName={"UM/Ticket"}
                          maxFiles={3}
                          label="فایل پیوست (حداکثر 3 فایل)"
                          onChange={handleFileChange("attachmentUrls")}
                          baseUrl={data.baseUrl}
                          placeholder={"فایل‌های مورد نظر را انتخاب کنید"}
                          accept="image/*,.pdf,.doc,.docx,.zip,.rar"
                          helperText="فرمت‌های مجاز: تصاویر، PDF، Word، Zip (حداکثر حجم هر فایل: 10MB)"
                          value={values.attachmentUrls}
                        />
                      </Grid>

 
                      <Grid
                        item
                        xs={12}
                        md={12}
                        container
                        justifyContent={"flex-end"}
                      >
                        <Button
                          disabled={isSubmitting}
                          variant="outlined"
                          size="large"
                          color="gray"
                          sx={{ mx: 1 }}
                          onClick={onNavigateToListPage}
                        >
                          انصراف
                        </Button>

                        <Button
                          disabled={isSubmitting}
                          variant="contained"
                          type="submit"
                          size="large"
                        >
                          {loading && (
                            <CircularProgress size={16} color="inherit" />
                          )}
                          {roleId !== "create" ? "ویرایش" : "ایجاد"}
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                );
              }}
            </Formik>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default TicketModifyPage;
